class BlogFilter {
  constructor() {
    this.tabs = document.querySelectorAll(".js-blog-cats .blog-cats__btn");
    this.grid = document.querySelector(".js-blog-grid");
    if (!this.tabs.length || !this.grid) return;
    this.bind();
  }
  bind() {
    this.tabs.forEach(btn => {
      btn.addEventListener("click", () => {
        const cat = btn.dataset.cat;
        this.tabs.forEach(b => b.classList.toggle("is-active", b === btn));
        this.grid.querySelectorAll(".blog-card").forEach(card => {
          if (cat === "all" || card.dataset.cat === cat) {
            card.style.display = "";
          } else {
            card.style.display = "none";
          }
        });
      });
    });
  }
}
export default BlogFilter;
